import { render, staticRenderFns } from "./airport-cabs-goa.vue?vue&type=template&id=54de8ac8&scoped=true"
import script from "./airport-cabs-goa.vue?vue&type=script&lang=js"
export * from "./airport-cabs-goa.vue?vue&type=script&lang=js"
import style0 from "./airport-cabs-goa.vue?vue&type=style&index=0&id=54de8ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de8ac8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
